import { render, staticRenderFns } from "./IconPlayTriangle.vue?vue&type=template&id=4d252ea8&scoped=true"
import script from "./IconPlayTriangle.vue?vue&type=script&lang=js"
export * from "./IconPlayTriangle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d252ea8",
  null
  
)

export default component.exports